import { MainContentArea, ContentHeader } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useBreadcrumb } from "../../hooks/navigation/useBreadcrumb";
import { AddDesignMappingButton } from "../../components/designMappings/AddDesignMappingButton";
import { DesignMappingsList } from "../../components/designMappings/DesignMappingsList";

export const DesignMappings: React.FC = () => {
  const { t } = useTranslation();
  const breadcrumb = useBreadcrumb("designMappings");

  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("designMappings.title")}
          breadcrumb={breadcrumb}
          extra={<AddDesignMappingButton />}
        />
      }
    >
      <DesignMappingsList />
    </MainContentArea>
  );
};
